const envConfigs = {
  "allkinds-au": require(`./config.allkinds-au.js`),
  "allkinds-us": require(`./config.allkinds-us.js`),
  "allkinds-staging": require(`./config.allkinds-staging.js`),
}

module.exports = {
  store: envConfigs[`${process.env.GATSBY_ACTIVE_STORE}`],
  stores: Object.entries(envConfigs)
    .filter(([key]) => (process.env.GATSBY_ACTIVE_STORE.includes("staging") ? key.includes("staging") : !key.includes("staging")))
    .reduce((all, store) => ({ ...all, [store[0]]: store[1] }), {}),
  theme: {
    color: "#000000",
    background: "#FFFFFF",
    display: "minimal-ui",
    icon: "static/images/icon.png",
    logo: "static/images/logo.svg",
  },
  settings: {
    cloudflare: {
      turnstile_verify_url: "https://challenges.cloudflare.com/turnstile/v0/siteverify",
      turnstile_key: "0x4AAAAAAA9ExX6YM9muaJir",
    },
    product: {
      sizeOptionName: "Size",
      colourOptionName: "Color",
      giftcardHandle: "gift-card",
      comingSoon: "coming-soon",
      outOfStock: "out-of-stock",
      backSoon: "back-soon",
      inStore: "in-store",
      bundle: "bundle",
      tags: {
        hidden: "hidden",
        donationProduct: "donation-product",
      },
      metafields: {
        yotpo: {
          namespace: "yotpo",
          keys: {
            reviews: "reviews",
            lastSynced: "last_synced",
          },
        },
      },
    },
    reactify: {
      includeFields: [
        "handle",
        "images",
        "presentment_price_ranges",
        "product_type",
        "tags",
        "variants",
        "metafields",
        "siblings",
        "related.handle",
        "related.id",
        "related.storefrontId",
        "related.title",
        "related.images",
        "related.featuredImage",
        "related.tags",
        "related.productType",
        "related.metafields",
        "related.variants",
      ],
      excludeFields: ["link"],
    },
    cart: {
      bundleIdAttribute: "_gift_bundle_id",
      bundleParentAttribute: "_bundle_parent",
      bundleDiscountAttribute: "_bundle_discount",
      bundleTitleAttribute: "_bundle_title",
      bundleImageAttribute: "_bundle_image",
      bundleHandleAttribute: "_bundle_handle",
      bundleAdditionalTextAttribute: "_bundle_additional_text",
      bundleAdditionalTextColorAttribute: "_bundle_additional_text_color",
      bundleTagsAttribute: "_bundle_tags",
      bundleComponentForAttribute: "Bundle item of",
      giftWrapAttribute: "_is-wrap",
      gwpAttribute: "_is-gwp",
      gwpAutoAdd: "_auto-add",
      gwpPercentage: "_gwp-percentage",
      giftUpsellText: "_additionalText",
      giftUpsellTextColor: "_additionalTextColor",
      giftcardRecipient: "_gift_recipient_name",
      giftSenderName: "_gift_sender_name",
      giftRecipientEmail: "_gift_recipient_email",
      giftRecipientDeliveryDate: "_gift_recipient_delivery_date",
      giftRecipientMessage: "_gift_recipient_message",
      giftRecipientItemRef: "_gift_recipient_item_ref",
      expiryTimeInDays: 14,
    },
    customer: {
      tagPrefix: "preferences",
      metafields: {
        birthDate: {
          namespace: "facts",
          key: "birth_date",
        },
      },
    },
    keys: {
      market: `market`,
      shopify: `shopify`,
      country: `country`,
      location: `location`,
      cart: `cart`,
      discounts: `discounts`,
      customer: `customer`,
      customerOther: `customerOther`,
      newsletter: `subscribe`,
      announcement: `announcement`,
      maintenance: `maintenance`,
      password: `password`,
      place: `place`,
      position: `position`,
      collectionScroll: `collectionScroll`,
      wishlistRegId: `wishlist`,
      wishlistSessionId: `wishlistSessionId`,
      wishlistSynced: `wishlistSynced`,
      geolocationDismissed: `geolocationDismissed`,
      promoActive: `promo`,
      authenticating: "authenticating",
      updatingAccount: "updatingAccount",
      hideCartReminder: "hideCartReminder",
      pdpTolstoyHeight: "pdpTolstoyHeight",
      ipapiCacheKey: "ipapi_location_cache",
    },
    params: {
      checkout: "checkout",
      continue: "return",
      customer: "key",
      giftcard: "redeem",
      variant: "variant",
      preview: "preview",
      cart: "cartSession",
    },
    routes: {
      HOMEPAGE: "/",
      FLEXIBLE: "",
      GENERIC: "",
      PAGE: "",
      ERROR: "/404",
      CART: "/cart",
      SEARCH: "/search",
      PASSWORD: "/password",
      SAVED: "/wishlist",
      WISHLIST_SHARED: "/wishlist/shared",
      GIFTCARD: "/balance",
      LOGIN: "/account/login",
      REGISTER: "/account/register",
      FORGOT: "/account/forgot",
      RESET: "/account/reset",
      ACTIVATE: "/account/activate",
      INVALID: "/account/invalid_token",
      DASHBOARD: "/account",
      ORDERS: "/account/orders",
      DETAILS: "/account/details",
      ADDRESSES: "/account/addresses",
      PREFERENCES: "/account/preferences",
      TV: "/tv",
      TV_SHOWS: "/shows",
      WISHLIST: "/wishlist",
      PRODUCT: "/products",
      BUNDLE: "/bundles",
      COLLECTION: "/collections",
      ARTICLE: "/articles",
      CATEGORY: "/articles/category",
      STORE: "/stores",
      INGREDIENTS: "/ingredients",
      INGREDIENT_CLASSES: "/ingredientclasses",
      SITEMAP: "/sitemap",
      INSTORE: "/instore-bookingform",
    },
    defaultRedirects: [],
    sitemapExclusions: [
      "/offline-plugin-app-shell-fallback",
      "/dev-404-page",
      "/404",
      "/404.html",
      "/password",
      "/preview",
      "/account",
      "/account/login",
      "/account/forgot",
      "/account/activate",
      "/account/reset",
      "/account/orders",
      "/account/addresses",
      "/account/preferences",
      "/wishlist",
      "/search",
      "/cart",
    ],
    postmark: {
      template: "AKAU-INSTORE-EXPERIENCE-PRD",
      from: "service@allkinds.com",
    },
    google: {
      googleMapsApiKey: "AIzaSyDV72nDJAovacKUEcOu3p5JMmqLbEVMEys",
      addressValidationEndpoint: "https://addressvalidation.googleapis.com/v1:validateAddress",
    },
    tagGateway: {
      url: "https://allkinds.com/metrics",
    },
    yotpo: {
      endpoints: {
        base: "https://api.yotpo.com/v1/widget/",
        bottomline: "https://api-cdn.yotpo.com",
      },
      customFieldIDS: {
        termsAndConditions: 1111,
      },
    },
  },
}
